import { useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { GoogleAuthProvider, OAuthProvider, signInWithCredential } from 'firebase/auth'
import { auth, googleProvider, appleProvider, signInWithPopup } from '../firebase'
import { IconClapper } from './icons'

export default function SignIn({ onClose, onSignedIn, message }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleGoogle = async () => {
    setLoading(true)
    setError(null)
    try {
      if (Capacitor.isNativePlatform()) {
        const { FirebaseAuthentication } = await import('@capacitor-firebase/authentication')
        const result = await FirebaseAuthentication.signInWithGoogle()
        const credential = GoogleAuthProvider.credential(result.credential?.idToken)
        const fbResult = await signInWithCredential(auth, credential)
        onSignedIn(fbResult.user)
      } else {
        const result = await signInWithPopup(auth, googleProvider)
        onSignedIn(result.user)
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleApple = async () => {
    setLoading(true)
    setError(null)
    try {
      if (Capacitor.isNativePlatform()) {
        const { FirebaseAuthentication } = await import('@capacitor-firebase/authentication')
        const result = await FirebaseAuthentication.signInWithApple()
        const provider = new OAuthProvider('apple.com')
        const credential = provider.credential({
          idToken: result.credential?.idToken,
          rawNonce: result.credential?.nonce,
        })
        const fbResult = await signInWithCredential(auth, credential)
        onSignedIn(fbResult.user)
      } else {
        const result = await signInWithPopup(auth, appleProvider)
        onSignedIn(result.user)
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleGuest = () => {
    onClose()
  }

  return (
    <div className="signin-overlay" onClick={onClose}>
      <div className="signin-card" onClick={(e) => e.stopPropagation()}>
        <div className="signin-card__icon" aria-hidden="true"><IconClapper size={40} /></div>
        <h2 className="signin-card__title">Join the Cast</h2>
        <p className="signin-card__subtitle">
          {message || 'Sign in to save your progress, unlock themes, and buy tickets.'}
        </p>

        <button
          type="button"
          className="signin-btn signin-btn--google"
          onClick={handleGoogle}
          disabled={loading}
        >
          <span style={{ fontWeight: 700, fontSize: '16px' }}>G</span>
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>

        <button
          type="button"
          className="signin-btn signin-btn--apple"
          onClick={handleApple}
          disabled={loading}
        >
          <span style={{ fontSize: '16px' }}></span>
          {loading ? 'Signing in…' : 'Continue with Apple'}
        </button>

        {error && <p className="signin-error">{error}</p>}

        <div className="signin-divider">or</div>

        <button
          type="button"
          className="signin-btn--guest"
          onClick={handleGuest}
        >
          Continue as Guest
        </button>

        <p className="signin-guest-note">
          Guests can play daily puzzles but can&apos;t purchase tickets or unlock themes.
        </p>
      </div>
    </div>
  )
}
